import React from "react";
import "./SoundsStyle.scss";
import { soundsTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";
import EmailSection from "components/EmailSection";

const SoundsSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="sounds-section">
      <div className="sounds-wrap">
        <SectionHeading>{soundsTextContent.headingText}</SectionHeading>

        <div className="sounds-box">
          <div className="text-box">
            <p className="para-text">{soundsTextContent.paraText}</p>

            {/* <EmailSection /> */}
            {/* <div className="btn-box">
              <CustomButton
                buttonType="secondary"
                label={soundsTextContent.btnText}
                onClick={handleButtonClick}
              />
            </div> */}
          </div>

          <div className="img-box">
            <img src={soundsTextContent.imageSrc} alt="Image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SoundsSection;
